import { Subject } from 'rxjs/Subject';

export class RequestEventEmitter extends Subject<String> {
    constructor() {
        super();
    }

    emit(value?: string) {
        super.next(value);
    }
}

export class ResponseEventEmitter extends Subject<String> {
    constructor() {
        super();
    }

    emit(value?: string) {
        super.next(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/emitter.ts